module.exports = "/assets/landing-cf/hero/cocktail.jpg?rXhRhqI";